import { render, staticRenderFns } from "./callbackResult.vue?vue&type=template&id=6f59bd00&scoped=true"
import script from "./callbackResult.vue?vue&type=script&lang=js"
export * from "./callbackResult.vue?vue&type=script&lang=js"
import style0 from "./callbackResult.vue?vue&type=style&index=0&id=6f59bd00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59bd00",
  null
  
)

export default component.exports